export const formatEUR = (amount) => {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: "always",
    minimumIntegerDigits: 1,
  }).format(n);
};

export const formatUSD = (amount) => {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export const formatCurrency = (amount, currency = "EUR") =>
  currency === "USD" ? formatUSD(amount) : formatEUR(amount);

export const formatNumber = (amount) => {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export const parseNumber = (str) => {
  if (typeof str === "number") return str;
  if (str === null || str === undefined || str === "") return 0;
  let s = String(str).trim().replace(/[€$\s]/g, "");
  if (!s) return 0;
  const hasComma = s.includes(",");
  const hasDot = s.includes(".");
  if (hasComma && hasDot) {
    // Spanish locale: "1.234,56" -> "1234.56"
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (hasComma) {
    // Only comma -> decimal separator
    s = s.replace(",", ".");
  }
  // Only dot OR nothing -> already in dot-decimal form (e.g., "1.08")
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
};

export const MONTHS_ES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const formatPeriod = (m, y) => `${MONTHS_ES[m - 1]} ${y}`;

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};
